import { Box } from "@mui/material";
import BodyWrapper from "components/BodyWrapper";
import { useGetPrivacyPolicyQuery } from "features/help/helpApiSlice";
import ResponsiveAppBar from "pages/Homepage/appBar";

export default function PrivacyPolicy() {
  const query = useGetPrivacyPolicyQuery();
  console.log("i need privacy", query);
  return (
    <BodyWrapper>
      <ResponsiveAppBar />
      <Box
        px={6}
        py={4}
        dangerouslySetInnerHTML={{ __html: query?.data?.privacy_policy }}
      />
    </BodyWrapper>
  );
}
